var render = function render(_c,_vm){return _c(_vm.props.tag,_vm._b({tag:"component",staticClass:"visually-hidden"},'component',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }